/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import type { ViewModel } from './view-model';

export function TradesView({ m }: { m: ViewModel }) {
  return (
    <div
      onClick={m.closeMenus}
      style={{ padding: '24px 12px 40px', display: 'flex', flexDirection: 'column', gap: '14px' }}
    >
      {' '}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        {' '}
        {(m.tradeRanges ?? []).map((r, i51) => (
          <Fragment key={i51}>
            {' '}
            <button
              className="scp-1b52e30"
              onClick={r?.go}
              title={dc.a(r?.label)}
              aria-label={`Show ${dc.s(r?.label)}`}
              style={dc.css(
                `font-size:11.5px;padding:6px 13px;border-radius:99px;border:1px solid ${dc.s(r?.bd)};background:${dc.s(r?.bg)};color:${dc.s(r?.fg)};cursor:pointer;font-weight:500`,
              )}
            >
              {dc.t(r?.label)}
            </button>{' '}
          </Fragment>
        ))}{' '}
        <span style={{ width: '1px', height: '18px', background: 'var(--l8)' }}></span>{' '}
        <div style={{ position: 'relative' }}>
          {' '}
          <button
            onClick={m.trAcctMenu?.toggle}
            aria-label="Filter by account"
            aria-expanded={dc.b(m.trAcctMenu?.open)}
            style={{
              fontSize: '11.5px',
              padding: '6px 13px',
              borderRadius: '99px',
              border: '1px solid var(--l10)',
              background: 'transparent',
              color: 'var(--muted)',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
            }}
          >
            {dc.t(m.trAcctMenu?.label)}
            <i className="ph ph-caret-down" style={{ fontSize: '10px', color: 'var(--faint)' }}></i>
          </button>{' '}
          {m.trAcctMenu?.open ? (
            <>
              {' '}
              <div
                style={{
                  position: 'absolute',
                  top: '34px',
                  left: '0',
                  zIndex: '20',
                  minWidth: '170px',
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  borderRadius: '16px',
                  boxShadow: 'var(--shadow-float)',
                  padding: '5px',
                }}
              >
                {' '}
                {(m.trAcctMenu?.items ?? []).map((i, i52) => (
                  <Fragment key={i52}>
                    {' '}
                    <button
                      className="scp-4f3e86a"
                      onClick={i?.go}
                      style={{
                        display: 'block',
                        width: '100%',
                        textAlign: 'left',
                        fontSize: '11.5px',
                        padding: '7px 11px',
                        border: 'none',
                        borderRadius: '9px',
                        background: 'transparent',
                        color: 'var(--text-mid)',
                        cursor: 'pointer',
                      }}
                    >
                      {dc.t(i?.label)}
                    </button>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </>
          ) : null}{' '}
        </div>{' '}
        <input
          value={dc.v(m.trQ)}
          onChange={m.setTrQ}
          placeholder="Symbol…"
          aria-label="Filter by symbol"
          style={{
            width: '110px',
            padding: '6px 13px',
            borderRadius: '99px',
            border: '1px solid var(--l10)',
            background: 'transparent',
            color: 'var(--text)',
            fontSize: '11.5px',
            outline: 'none',
          }}
        />{' '}
        <div style={{ position: 'relative' }}>
          {' '}
          <button
            onClick={m.trSideMenu?.toggle}
            aria-label="Filter by side"
            aria-expanded={dc.b(m.trSideMenu?.open)}
            style={{
              fontSize: '11.5px',
              padding: '6px 13px',
              borderRadius: '99px',
              border: '1px solid var(--l10)',
              background: 'transparent',
              color: 'var(--muted)',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
            }}
          >
            {dc.t(m.trSideMenu?.label)}
            <i className="ph ph-caret-down" style={{ fontSize: '10px', color: 'var(--faint)' }}></i>
          </button>{' '}
          {m.trSideMenu?.open ? (
            <>
              {' '}
              <div
                style={{
                  position: 'absolute',
                  top: '34px',
                  left: '0',
                  zIndex: '20',
                  minWidth: '150px',
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  borderRadius: '16px',
                  boxShadow: 'var(--shadow-float)',
                  padding: '5px',
                }}
              >
                {' '}
                {(m.trSideMenu?.items ?? []).map((i, i53) => (
                  <Fragment key={i53}>
                    {' '}
                    <button
                      className="scp-4f3e86a"
                      onClick={i?.go}
                      style={{
                        display: 'block',
                        width: '100%',
                        textAlign: 'left',
                        fontSize: '11.5px',
                        padding: '7px 11px',
                        border: 'none',
                        borderRadius: '9px',
                        background: 'transparent',
                        color: 'var(--text-mid)',
                        cursor: 'pointer',
                      }}
                    >
                      {dc.t(i?.label)}
                    </button>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </>
          ) : null}{' '}
        </div>{' '}
        <div style={{ position: 'relative' }}>
          {' '}
          <button
            onClick={m.trStratMenu?.toggle}
            aria-label="Filter by strategy"
            aria-expanded={dc.b(m.trStratMenu?.open)}
            style={{
              fontSize: '11.5px',
              padding: '6px 13px',
              borderRadius: '99px',
              border: '1px solid var(--l10)',
              background: 'transparent',
              color: 'var(--muted)',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
            }}
          >
            {dc.t(m.trStratMenu?.label)}
            <i className="ph ph-caret-down" style={{ fontSize: '10px', color: 'var(--faint)' }}></i>
          </button>{' '}
          {m.trStratMenu?.open ? (
            <>
              {' '}
              <div
                style={{
                  position: 'absolute',
                  top: '34px',
                  left: '0',
                  zIndex: '20',
                  minWidth: '210px',
                  background: 'var(--surface)',
                  border: '1px solid var(--card-line)',
                  borderRadius: '16px',
                  boxShadow: 'var(--shadow-float)',
                  padding: '5px',
                }}
              >
                {' '}
                {(m.trStratMenu?.items ?? []).map((i, i54) => (
                  <Fragment key={i54}>
                    {' '}
                    <button
                      className="scp-4f3e86a"
                      onClick={i?.go}
                      style={{
                        display: 'block',
                        width: '100%',
                        textAlign: 'left',
                        fontSize: '11.5px',
                        padding: '7px 11px',
                        border: 'none',
                        borderRadius: '9px',
                        background: 'transparent',
                        color: 'var(--text-mid)',
                        cursor: 'pointer',
                      }}
                    >
                      {dc.t(i?.label)}
                    </button>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
            </>
          ) : null}{' '}
        </div>{' '}
        <div style={{ flex: '1' }}></div>{' '}
        <span style={{ fontSize: '11px', color: 'var(--faint)', fontVariantNumeric: 'tabular-nums' }}>
          {dc.t(m.trCount)}
        </span>{' '}
        <button
          onClick={m.trRefresh}
          title="Resync from MetaAPI"
          aria-label="Resync trades from MetaAPI"
          style={{
            fontSize: '11.5px',
            padding: '6px 13px',
            borderRadius: '99px',
            border: '1px solid var(--l10)',
            background: 'transparent',
            color: 'var(--muted)',
            cursor: 'pointer',
          }}
        >
          <i className="ph ph-arrows-clockwise" style={{ fontSize: '12px' }}></i>
        </button>{' '}
        <button
          onClick={m.trExport}
          title="Export filtered trades to CSV"
          aria-label="Export filtered trades to CSV"
          style={{
            fontSize: '11.5px',
            padding: '6px 13px',
            borderRadius: '99px',
            border: '1px solid var(--l10)',
            background: 'transparent',
            color: 'var(--muted)',
            cursor: 'pointer',
          }}
        >
          <i className="ph ph-download-simple" style={{ fontSize: '12px' }}></i>
        </button>{' '}
      </div>{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit,minmax(140px,1fr))',
        }}
      >
        {' '}
        <div style={{ padding: '13px 16px', borderRight: '1px solid var(--l6)' }}>
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Net P&L
          </div>
          <div
            style={dc.css(
              `font-size:14px;font-weight:600;color:${dc.s(m.trNetFg)};margin-top:4px;font-variant-numeric:tabular-nums`,
            )}
          >
            {dc.t(m.trNet)}
          </div>
        </div>{' '}
        <div style={{ padding: '13px 16px', borderRight: '1px solid var(--l6)' }}>
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Gross P&L
          </div>
          <div
            style={{
              fontSize: '14px',
              fontWeight: '600',
              marginTop: '4px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {dc.t(m.trGross)}
          </div>
        </div>{' '}
        <div style={{ padding: '13px 16px', borderRight: '1px solid var(--l6)' }}>
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Commission
          </div>
          <div
            style={{
              fontSize: '14px',
              fontWeight: '600',
              color: 'var(--muted)',
              marginTop: '4px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {dc.t(m.trComm)}
          </div>
        </div>{' '}
        <div style={{ padding: '13px 16px', borderRight: '1px solid var(--l6)' }}>
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Win rate
          </div>
          <div
            style={{
              fontSize: '14px',
              fontWeight: '600',
              marginTop: '4px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {dc.t(m.trWr)}
          </div>
        </div>{' '}
        <div style={{ padding: '13px 16px', borderRight: '1px solid var(--l6)' }}>
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Avg win
          </div>
          <div
            style={{
              fontSize: '14px',
              fontWeight: '600',
              color: 'var(--pos)',
              marginTop: '4px',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {dc.t(m.trAvgWin)}
          </div>
        </div>{' '}
        <div style={{ padding: '13px 16px', borderRight: '1px solid var(--l6)' }}>
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            Avg loss
          </div>
          <div
            style={dc.css(
              `font-size:14px;font-weight:600;color:${dc.s(m.trAvgLossFg)};margin-top:4px;font-variant-numeric:tabular-nums`,
            )}
          >
            {dc.t(m.trAvgLoss)}
          </div>
        </div>{' '}
        <div style={{ padding: '13px 16px' }}>
          <div
            style={{
              fontSize: '9px',
              letterSpacing: '0.11em',
              textTransform: 'uppercase',
              color: 'var(--muted2)',
              fontWeight: '600',
            }}
          >
            SL/TP tagged
          </div>
          <div
            style={dc.css(
              `font-size:14px;font-weight:600;color:${dc.s(m.trTaggedFg)};margin-top:4px;font-variant-numeric:tabular-nums`,
            )}
          >
            {dc.t(m.trTagged)}
          </div>
        </div>{' '}
      </div>{' '}
      {m.trHasSel ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              padding: '10px 16px',
              borderColor: 'color-mix(in srgb, var(--acc-fill) 35%, transparent)',
            }}
          >
            {' '}
            <span style={{ fontSize: '11.5px', fontWeight: '500', fontVariantNumeric: 'tabular-nums' }}>
              {dc.t(m.trSelCount)}
            </span>{' '}
            <div style={{ flex: '1' }}></div>{' '}
            <button
              onClick={m.trTagSel}
              title="Tag selection to a strategy"
              aria-label="Tag selection to a strategy"
              style={{
                fontSize: '11px',
                padding: '5px 13px',
                borderRadius: '99px',
                border: '1px solid color-mix(in srgb, var(--acc-fill) 50%, transparent)',
                background: 'color-mix(in srgb, var(--acc-fill) 10%, transparent)',
                color: 'var(--acc)',
                cursor: 'pointer',
              }}
            >
              Tag strategy
            </button>{' '}
            <button
              onClick={m.trExport}
              title="Export selection"
              aria-label="Export selection"
              style={{
                fontSize: '11px',
                padding: '5px 13px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                background: 'transparent',
                color: 'var(--muted)',
                cursor: 'pointer',
              }}
            >
              Export
            </button>{' '}
            <button
              onClick={m.trClearSel}
              title="Clear selection"
              aria-label="Clear selection"
              style={{
                fontSize: '11px',
                padding: '5px 13px',
                borderRadius: '99px',
                border: '1px solid var(--l10)',
                background: 'transparent',
                color: 'var(--muted)',
                cursor: 'pointer',
              }}
            >
              Clear
            </button>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--card-line)',
          boxShadow: 'var(--shadow-card)',
          borderRadius: '16px',
          overflow: 'hidden',
        }}
      >
        {' '}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '26px 1.15fr 0.8fr 0.8fr 0.6fr 0.5fr 0.9fr 0.9fr 0.9fr 0.7fr 1.1fr 0.6fr',
            gap: '0 8px',
            alignItems: 'center',
            fontSize: '9px',
            letterSpacing: '0.11em',
            textTransform: 'uppercase',
            color: 'var(--muted2)',
            fontWeight: '600',
            padding: '10px 16px',
            borderBottom: '1px solid var(--l8)',
          }}
        >
          {' '}
          <span>
            <input
              type="checkbox"
              checked={!!m.trSelAll}
              onChange={m.trSelAllToggle}
              aria-label="Select all filtered trades"
              style={{ accentColor: 'var(--acc-fill)' }}
            />
          </span>{' '}
          <span>
            <button
              onClick={m.trSortDate}
              aria-label="Sort by date"
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                padding: '0',
              }}
            >
              {'Date '}
              {dc.t(m.trDateArrow)}
            </button>
          </span>{' '}
          <span>Account</span>
          <span>Symbol</span>
          <span>Side</span>
          <span style={{ textAlign: 'right' }}>Lots</span>
          <span style={{ textAlign: 'right' }}>Entry</span>
          <span style={{ textAlign: 'right' }}>Exit</span>{' '}
          <span style={{ textAlign: 'right' }}>
            <button
              onClick={m.trSortPnl}
              aria-label="Sort by net P and L"
              style={{
                fontSize: '9px',
                letterSpacing: '0.11em',
                textTransform: 'uppercase',
                color: 'var(--muted2)',
                fontWeight: '600',
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                padding: '0',
              }}
            >
              {'Net P&L '}
              {dc.t(m.trPnlArrow)}
            </button>
          </span>{' '}
          <span style={{ textAlign: 'right' }}>Duration</span>
          <span>Strategy</span>
          <span style={{ textAlign: 'right' }}>SL/TP</span>{' '}
        </div>{' '}
        {m.trHasRows ? (
          <>
            {' '}
            <div>
              {' '}
              {(m.trRows ?? []).map((t, i55) => (
                <Fragment key={i55}>
                  {' '}
                  <div
                    className="scp-4f3e86a"
                    style={dc.css(
                      `display:grid;grid-template-columns:26px 1.15fr 0.8fr 0.8fr 0.6fr 0.5fr 0.9fr 0.9fr 0.9fr 0.7fr 1.1fr 0.6fr;gap:0 8px;align-items:center;font-size:11.5px;padding:9px 16px;border-bottom:1px solid var(--l8);background:${dc.s(t?.rowBg)}`,
                    )}
                  >
                    {' '}
                    <span>
                      <input
                        type="checkbox"
                        checked={!!t?.sel}
                        onChange={t?.toggle}
                        aria-label={`Select trade ${dc.s(t?.sym)} ${dc.s(t?.date)}`}
                        style={{ accentColor: 'var(--acc-fill)' }}
                      />
                    </span>{' '}
                    <span style={{ color: 'var(--text-mid)', fontVariantNumeric: 'tabular-nums' }}>
                      {dc.t(t?.date)}
                    </span>{' '}
                    <span style={{ color: 'var(--muted2)' }}>{dc.t(t?.acct)}</span>{' '}
                    <span style={{ fontWeight: '500' }}>{dc.t(t?.sym)}</span>{' '}
                    <span>
                      <span
                        style={dc.css(
                          `font-size:9px;font-weight:600;letter-spacing:0.06em;padding:2px 8px;border-radius:99px;background:${dc.s(t?.sideBg)};color:${dc.s(t?.sideFg)}`,
                        )}
                      >
                        {dc.t(t?.side)}
                      </span>
                    </span>{' '}
                    <span
                      style={{
                        textAlign: 'right',
                        color: 'var(--muted)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(t?.lots)}
                    </span>{' '}
                    <span
                      style={{
                        textAlign: 'right',
                        color: 'var(--muted)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(t?.entry)}
                    </span>{' '}
                    <span
                      style={{
                        textAlign: 'right',
                        color: 'var(--muted)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(t?.exit)}
                    </span>{' '}
                    <span
                      style={dc.css(
                        `text-align:right;color:${dc.s(t?.pnlFg)};font-weight:600;font-variant-numeric:tabular-nums`,
                      )}
                    >
                      {dc.t(t?.pnl)}
                    </span>{' '}
                    <span
                      style={{
                        textAlign: 'right',
                        color: 'var(--muted2)',
                        fontVariantNumeric: 'tabular-nums',
                      }}
                    >
                      {dc.t(t?.dur)}
                    </span>{' '}
                    <span
                      style={{
                        color: 'var(--muted2)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {dc.t(t?.strat)}
                    </span>{' '}
                    <span style={{ textAlign: 'right' }}>
                      <span
                        style={dc.css(
                          `font-size:9.5px;padding:2px 9px;border-radius:99px;border:1px solid ${dc.s(t?.tagBd)};color:${dc.s(t?.tagFg)}`,
                        )}
                      >
                        {dc.t(t?.tagLabel)}
                      </span>
                    </span>{' '}
                  </div>{' '}
                </Fragment>
              ))}{' '}
            </div>{' '}
          </>
        ) : null}{' '}
        {m.trNoRows ? (
          <>
            {' '}
            <div style={{ padding: '34px', textAlign: 'center' }}>
              <i
                className="ph ph-list-magnifying-glass"
                style={{ fontSize: '26px', color: 'var(--ghost)' }}
              ></i>
              <div style={{ fontSize: '12.5px', color: 'var(--text-mid)', marginTop: '9px' }}>
                {dc.t(m.trEmptyMsg)}
              </div>
              <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '3px' }}>
                Widen the range or clear a filter.
              </div>
            </div>{' '}
          </>
        ) : null}{' '}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 16px' }}>
          {' '}
          <span style={{ fontSize: '10.5px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
            {dc.t(m.trPager)}
          </span>{' '}
          <div style={{ flex: '1' }}></div>{' '}
          <span style={{ fontSize: '10.5px', color: 'var(--muted2)', fontVariantNumeric: 'tabular-nums' }}>
            {dc.t(m.trPageLabel)}
          </span>{' '}
          <button
            onClick={m.trPrev}
            disabled={!!m.trPrevDis}
            title="Previous page"
            aria-label="Previous page"
            style={dc.css(
              `width:26px;height:26px;border-radius:9px;border:1px solid var(--l8);background:transparent;color:var(--faint);cursor:pointer;opacity:${dc.s(m.trPrevOp)}`,
            )}
          >
            <i className="ph ph-caret-left" style={{ fontSize: '12px' }}></i>
          </button>{' '}
          <button
            onClick={m.trNext}
            disabled={!!m.trNextDis}
            title="Next page"
            aria-label="Next page"
            style={dc.css(
              `width:26px;height:26px;border-radius:9px;border:1px solid var(--l8);background:transparent;color:var(--faint);cursor:pointer;opacity:${dc.s(m.trNextOp)}`,
            )}
          >
            <i className="ph ph-caret-right" style={{ fontSize: '12px' }}></i>
          </button>{' '}
        </div>{' '}
      </div>
    </div>
  );
}
